import { IWorkflowStepState } from "../../../../@types/admin/AdminWorkflow";
import { humanizeEnumName } from "../../../../utils/enumNames";

/**
 * Presentation helpers for the executed-step timeline (EN-5167).
 *
 * The API sends enum NAMES ("FollowUpQuestion", "WaitingWorkflowEvent");
 * Retool's SQL returned the raw integers and its tables showed them as
 * numbers. These turn a name into something an operator reads.
 */

// humanizeEnumName lives in utils/enumNames.ts since EN-5168 gave it a second
// consumer (the Baselines page's measurement types and comparators) — the rule
// is generic. Re-exported so this module's callers and tests are unaffected.
export { humanizeEnumName } from "../../../../utils/enumNames";

/** What this step was, in a few words. */
export function describeStep(step: IWorkflowStepState): string {
  if (step.stepType === "Rule") {
    return step.ruleType ? `${humanizeEnumName(step.ruleType)} rule` : "Rule";
  }
  return step.responseType ? humanizeEnumName(step.responseType) : "Response";
}

/**
 * When a response was due. `Immediately` needs no time; `NextDay` carries the
 * time of day it was scheduled for.
 */
export function describeStepTiming(step: IWorkflowStepState): string | null {
  if (!step.timeType) return null;
  if (step.timeType === "Immediately") return "Immediately";
  // HH:mm:ss → HH:mm; a NextDay response with no time is still "Next day".
  const time = step.time ? step.time.slice(0, 5) : null;
  return time ? `Next day at ${time}` : "Next day";
}

/** Done steps get a filled marker; waiting ones an outline. */
export function isStepDone(step: IWorkflowStepState): boolean {
  return step.status === "Done";
}
